import { SlideItemType } from '../enums';
import { QuestionSlideItemType } from '../zod/slideTypes/questionSlideSchema';
import { SelectableAnswerSlideItemType } from '../zod/slideTypes/slideItemTypes/answerSlideItemTypes/selectableAnswerSlideItemSchema';

export function isSlideItemSelectableAnswerItem(
  item: QuestionSlideItemType
): item is SelectableAnswerSlideItemType {
  return item.type === SlideItemType.ANSWER_SELECTABLE;
}
